var render, staticRenderFns
import script from "./SelectionCard.vue?vue&type=script&lang=ts&"
export * from "./SelectionCard.vue?vue&type=script&lang=ts&"
import style0 from "./SelectionCard.vue?vue&type=style&index=0&id=6dd48a68&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports